import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { PageSubTitle, Text } from 'components/common/Elements/Elements';

import { textToDate, textToTime } from 'utils/common';
import { accessDuration } from './helpers/helpers';

import classes from './Widgets.module.scss';

const Widgets = ({ data }) => {
  const { t } = useTranslation(['activity']);

  return (
    <section className={classes.box}>
      <PageSubTitle
        hiden
        title={t('activity:team.TEAM_ACCESS_WIDGETS')}
        size={3}
      />
      <Text
        type="p"
        className={cn(
          classes.widget,
          data.status !== 'Active' && classes.widget_notActivStatus
        )}
      >
        <Text weight="r" className={classes.heading}>
          {t('activity:team.SUPPORT_ACCESS')}
          {data.status !== 'Active' && (
            <Text type="s" className={classes.heading_granted}>
              {` (${t('activity:team.EXPIRIED')}: ${textToDate(
                data.createdAt
              )} ${textToTime(data.createdAt)})`}
            </Text>
          )}
        </Text>

        <Text
          weight="b"
          className={cn(classes.text, classes[`text_${data.status}`])}
        >
          {data.status}
        </Text>
      </Text>

      {data.status === 'Active' && (
        <>
          <div className={classes.widget}>
            <Text weight="r" className={classes.heading}>
              {t('activity:team.ACCESS_DURATION')}
              <Text type="s" className={classes.heading_granted}>
                {` (${t('activity:team.GRANTED_ON')}: ${textToDate(
                  data.createdAt
                )} ${textToTime(data.createdAt)})`}
              </Text>
            </Text>
            <Text weight="b" className={cn(classes.text)}>
              {accessDuration(data.createdAt, data.expiresAt, 1)}
            </Text>
          </div>
          <div className={classes.widget}>
            <Text weight="r" className={classes.heading}>
              {t('activity:team.REMAINING_ACCESS')}
              <Text type="s" className={classes.heading_granted}>
                {` (${t('activity:team.EXPIRIED_ON')}: ${textToDate(
                  data.expiresAt
                )} ${textToTime(data.expiresAt)})`}
              </Text>
            </Text>
            <Text weight="b" className={cn(classes.text)}>
              {accessDuration(undefined, data.expiresAt)}
            </Text>
          </div>
        </>
      )}
    </section>
  );
};

Widgets.propTypes = {
  data: PropTypes.object.isRequired
};

export default Widgets;
